/* istanbul ignore file */
export default {
  stage: {
    type: 'string',
    required: true,
  },
  specialization: {
    type: 'string',
    required: {
      value: true,
      message: 'Please select the specialization',
    },
  },
  technology: {
    type: 'string',
    required: false,
  },
  level: {
    type: 'string',
    required: {
      value: true,
      message: 'Please select the level',
    },
  },
};
